<template>
	<a-card :body-style="{padding: '24px 32px'}" :bordered="false">
		<a-form-model layout="inline" @submit="handleSearch" @submit.native.prevent>
			<a-form-model-item>
				<company-search
					v-model="search.company"
					placeholder="请选择所属公司"
				/>
			</a-form-model-item>
			<a-form-model-item>
				<a-range-picker
					valueFormat="YYYY-MM-DD"
					v-model="searchRange"
				/>
			</a-form-model-item>
			<a-form-model-item>
				<a-button
					type="primary"
					html-type="submit"
					icon="search"
				>
					查询
				</a-button>
			</a-form-model-item>
		</a-form-model>
		<a-divider />
		<a-table
			:loading="loading"
			:columns="columns"
			:data-source="list"
			:scroll="{y: 500 }"
			:pagination="pager"
			rowKey="_id"
			@change="change">
			<span slot="user" slot-scope="text, record">
          <a-avatar :src="record.user.headimgurl" />
          <span style="margin-left: 10px">{{ record.user.nickname }}</span>
        </span>
		</a-table>
	</a-card>
</template>
<script>
import { partnerDeduct } from '@/api/financial';

export default {
  data() {
    return {
    	search: {},
		  list: [],
		  pager: {},
		  loading: false,
	    searchRange: [],
    };
  },
  created() {
  	this.getList();
  },
  computed: {
	  columns() {
	  	return [
		  {
			  title: '#',
			  dataIndex: 'index',
			  customRender: (text, row, index) => index + 1,
			  key: 'index',
			  width: '50px',
		  },
		  {
			  title: '公司',
			  dataIndex: 'company.name',
			  key: 'companyName',
		  },
		  {
			  title: '站点',
			  dataIndex: 'station.name',
			  key: 'stationName',
		  },
		  {
			  title: '用户',
			  dataIndex: 'user.nickName',
			  key: 'nickName',
		    scopedSlots: { customRender: 'user' },
		  },
		  {
			  title: '单号',
			  dataIndex: 'code',
			  key: 'code',
		  },
		  {
			  title: '单价',
			  dataIndex: 'unitprice',
			  key: 'unitprice',
		  },
		  {
			  title: '格子规格',
			  dataIndex: 'cabinet.boxSize',
			  key: 'boxSize',
		  },
		  {
			  title: '时间',
			  dataIndex: 'ctime',
			  key: 'ctime',
		  },
	  ];
	  },
  },
  methods: {
  	async getList() {
  		this.loading = true;
	    const q = this.search;
	    q.start = this.searchRange[0];
	    q.end = this.searchRange[1];
  		const { data: { docs, pager } } = await partnerDeduct(q);
  		this.list = docs;
  		this.pager = {
		    ...pager,
		    showTotal: (total) => `共计 ${total} 条信息`,
		  };
	    this.loading = false;
	  },
	  change(pagination) {
		  this.search.page = pagination.current;
		  this.getList();
	  },
	  handleSearch() {
		  this.getList();
	  },
  },
};
</script>
<style lang="less">

</style>
